import { ShippingClaimPhotoSchema } from "@redotech/redo-model/shipping-claims/shipping-claim";
import * as z from "zod/v4";

export const submitAdditionalShippingClaimPhotos = {
  name: "submitAdditionalShippingClaimPhotos" as const,
  input: z.object({
    claimId: z.string(),
    photos: z.array(ShippingClaimPhotoSchema),
  }),
  output: z.object({
    success: z.boolean(),
    message: z.string(),
    newPhotosCount: z.number(),
  }),
};
